/*
* Copyright 2026 Tecnalia, Basque Research & Technology Alliance (BRTA)
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*
*  SPDX-License-Identifier: Apache-2.0
*/

export interface Distribution {
    "@type": string;
    "dct:format": {
        "@id": string;
    };
    "dcat:accessService": {
        "@id": string;
        "@type": string;
    };
}

export interface Offer {
    "@id": string;
    "@type": string;
    "odrl:permission"?: unknown;
    "odrl:prohibition"?: unknown;
    "odrl:obligation"?: unknown;
    [key: string]: unknown;
}

export interface DataService {
    "@id": string;
    "@type": string;
    "dcat:endpointDescription"?: string;
    "dcat:endpointUrl"?: string;
    "dcat:endpointURL"?: string;
}

export interface Dataset {
    "@id": string;
    "@type": string;
    "id"?: string;
    "name"?: string;
    "prop1"?: string;
    "version"?: string;
    "contenttype"?: string;
    "odrl:hasPolicy": Offer | Offer[];
    "dcat:distribution": Distribution[];
    [key: string]: unknown;
}

export function normalizeDatasetOffers(policy: Offer | Offer[] | undefined): Offer[] {
    if (policy == null) {
        return [];
    }
    return Array.isArray(policy) ? policy : [policy];
}

export interface Catalog {
    "@id": string;
    "@type": string;
    "dcat:dataset": Dataset | Dataset[];
    "dcat:catalog": unknown[];
    "dcat:distribution": unknown[];
    "dcat:service"?: DataService | DataService[];
    "dspace:participantId"?: string;
    "originator": string;
    "@context": {
        "@vocab": string;
        "dct"?: string;
        "edc"?: string;
        "dcat"?: string;
        "odrl"?: string;
        "dspace"?: string;
        [key: string]: unknown;
    };
}